import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/Shop/ProductDetail';
import Custom from './pages/Custom';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Cart from './pages/Cart';
import Account from './pages/Account';
import Signup from './pages/Auth/Signup';
import Login from './pages/Auth/Login';
import ConfirmSignup from './pages/Auth/ConfirmSignup';
import ForgotPassword from './pages/Auth/ForgotPassword';

import { CartProvider } from './context/CartContext';


import AdminHome from './pages/Admin/AdminHome';
import ProtectedAdminRoute from './components/Admin/ProtectedAdminRoute';

import './styles/global.css';
import 'yet-another-react-lightbox/styles.css';

function App() {
  return (
    <Router>
      <CartProvider>
        <Navbar />
        <div className="site-wrapper">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/product/:productId" element={<ProductDetail />} />
            <Route path="/custom" element={<Custom />} />
            <Route path="/about" element={<About />} />
            {/* <Route path="/gallery" element={<Gallery />} /> */}
            <Route path="/cart" element={<Cart />} />
            <Route path="/account" element={<Account />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/confirm" element={<ConfirmSignup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            <Route
              path="/admin"
              element={
                <ProtectedAdminRoute>
                  <AdminHome />
                </ProtectedAdminRoute>
              }
            />
          </Routes>
        </div>
      </CartProvider>
    </Router>
  );
}

export default App;